import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';


import * as $ from "jquery";


import { SessionService } from '../../shared/services/session.service';

@Component({
  selector: 'app-yr3-st-bladderblocket',
  templateUrl: './yr3-st-bladderblocket.component.html',
  styleUrls: ['./yr3-st-bladderblocket.component.scss']
})

export class Yr3StBladderblocketComponent implements OnInit {
  public bloburl: string;


  constructor(private sessionService: SessionService, public thisDialogRef: MatDialogRef<Yr3StBladderblocketComponent>, @Inject(MAT_DIALOG_DATA) public data: string) {
    this.bloburl = this.sessionService.bloburl;
  }

  ngOnInit() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
      if (ua.indexOf('chrome') > -1) {

      } else {
        $("body").addClass("mac");
      }
    }
  }
  //New concept for print btn
  autoprintloadText(event: any) {
    var txtChar = event.key;
    if (txtChar) {
      this.hideshowprintbtn(1);
    }
  }

  hideshowprintbtn(st: any) {
    if (st == 1) {
      $("#printpdf").removeClass("disabled_me");
    }
    else {
      $("#printpdf").addClass("disabled_me");
    }
  }

  removeText() {
    var thisme = this;
    setTimeout(function () {
      var b = $("#textfield").text();
      var images = $(".draggableme");
      if (b == "" && images) {
        if (images.length == 0) {
          thisme.hideshowprintbtn(2);
        }
      }
      else if (b == "") {
        thisme.hideshowprintbtn(2);
      }
    }, 100);
  }
  //New concept


  async ngAfterViewInit() {    

    var text_editor_container = document.querySelector("#textfield");
    var editor = document.getElementById("#textfield");
    text_editor_container.addEventListener("touchstart", this.touchHandler, true);
    text_editor_container.addEventListener("touchmove", this.touchHandler, true);
    text_editor_container.addEventListener("touchend", this.touchHandler, true);
    text_editor_container.addEventListener("touchcancel", this.touchHandler, true);

    text_editor_container.addEventListener("touchstart", removeborders);
    function removeborders(e) {
      if ($(e.target).attr('class') != 'draggableme' || $(e.target).attr('class') != 'draggableme1') {

       
        $(".draggableme").css("border", "none");
        $(".closeimg").css("display", "none");
        $(".draggableme1").css("border", "none");
      }
    }
  } 

  touchHandler(event) {


    var touch = event.changedTouches[0];

    var simulatedEvent = document.createEvent("MouseEvent");
    simulatedEvent.initMouseEvent({
      touchstart: "mousedown",
      touchmove: "mousemove",
      touchend: "mouseup"
    }[event.type], true, true, window, 1,
      touch.screenX, touch.screenY,
      touch.clientX, touch.clientY, false,
      false, false, false, 0, null);

    if ($(event.target).attr('class') == 'draggableme' || $(event.target).attr('class') == 'draggableme1') {
      touch.target.dispatchEvent(simulatedEvent);
    }
   

  }

  toggleTable1(i, k) {

    var TableA1 = document.getElementById("yr3_st_bladder_imageTable2");
    var TableA2 = document.getElementById("yr3_st_bladder_imageTable3");
    var imgarr11: any[string];
    imgarr11 = [TableA1, TableA2];

    if (imgarr11[i].style.display === "table") {
      imgarr11[i].style.display = "none";
      imgarr11[k].style.display = "none";
    } else {
      imgarr11[i].style.display = "table";
      imgarr11[k].style.display = "none";
    }

  }

  changeColor(i, k) {


    var e1 = document.getElementById("bladdercircle1");
    var c1 = window.getComputedStyle(e1).backgroundColor;

    var e2 = document.getElementById("bladdercircle2");
    var c2 = window.getComputedStyle(e2).backgroundColor;

    var circlearr: any[string];
    circlearr = [e1, e2];

    var circlearr1: any[string];
    circlearr1 = [c1, c2];

    if (circlearr1[i] === "rgb(255, 255, 255)") {
      circlearr[i].style.background = "#ED8505";
      circlearr[k].style.background = "#FFFFFF";
    } else {
      circlearr[i].style.background = "#FFFFFF";
      circlearr[k].style.background = "#FFFFFF";
    }
  }

  showtext(t) {
    var bloburl = this.sessionService.bloburl;
    var choosetext = document.getElementById("choosetext");

    for (var s = 0; s < choosetext.children.length; s++) {
      if (choosetext.children[s].className == "finalBlock") {
        choosetext.removeChild(choosetext.children[s]);
        s = s - 1;
      }
    }

    var elem1: any = document.getElementById("textfield");
    elem1.innerHTML = '';

    var text1 = ["1. Ojdå, vad kommer att hända här, tror du?", "Berätta.", "2. Skriv en berättelse om en busig katt."];
    var text1_top = [30, 43, 56];
    var text1_left = [2, 7, 2];



    var text2 = ["1. Vilket spel tycker du bäst om? Berätta.", "2. Skriv en instruktion om hur man spelar ett", "tärningsspel."];
    var text2_top = [30, 43, 56];
    var text2_left = [2, 2, 7];

    var text3 = ["1. Hur känner sig personen och vad läser hen,", "tror du? Berätta.",
      "2. Skriv dagbok om eftermiddagen då du", "råkade bli inlåst i skolbiblioteket ..."];
    var text3_top = [30, 43, 56, 69];
    var text3_left = [2, 7, 2, 7];


    var text4 = ["1. Vad står den här personen och tänker på,", "tror du? Berätta.",
      "2. Skriv en berättelse med rubriken", "”En tågresa jag aldrig glömmer ...” ."   
    ];
    var text4_top = [30, 43, 56, 69];
    var text4_left = [2, 7, 2, 7];

    var text5 = ["1. Vad skulle du göra om de här pandorna satt", "och väntade utanför din dörr en morgon?", "Berätta.",
      "2. Skriv en faktatext om pandor."      
    ];
    var text5_top = [30, 43, 56, 69];
    var text5_left = [2,7,7, 2];

    var text6 = ["1. Vad är skillnaden mellan att campa och", "att bo i en stuga? Berätta.",
      "2. Vad pratar barnen om? Skriv en dialog."    
    ];
    var text6_top = [30, 43, 56];
    var text6_left = [2,7, 2];

    var text7 = ["1. Tänk dig att du precis läst ett brev du fått.", "Vad handlade det om? Berätta.",
      "2. Skriv ett brev till någon du känner eller", "någon du vill lära känna."   
    ];
    var text7_top = [30, 43,56, 69];
    var text7_left = [2, 7, 2, 7];

    var text8 = ["1. Idag är det du som är klassens vikarie.", "Hur ser dagens schema ut, tänker du?", "Berätta.",
      "2. Skriv en efterlysning av din lärare."     
    ];
    var text8_top = [30, 43, 56, 69];
    var text8_left = [2, 7, 7, 2];

    var text9 = ["1. Tänk dig att du har gått ombord på den här", "ubåten och åkt med ner i havet. Berätta.",
      "2. Skriv en dikt om hur det kan vara", "under ytan."    
    ];
    var text9_top = [30, 43, 56, 69];
    var text9_left = [2, 7, 2, 7];

    var text10 = ["1. Hur går det till när du bakar? Berätta.",
      "2. Skriv ett recept som passar till rubriken", "”Världens godaste kaka”."     
    ];
    var text10_top = [30, 43, 56];
    var text10_left = [2, 2, 7];

    var text11 = ["1. Vad kan man bygga med klossar? Berätta.",
      "2. Skriv en instruktion om hur man ska lägga", "klossarna så att det ser ut precis", "som på bilden."      
    ];
    var text11_top = [30, 43, 56, 69];
    var text11_left = [2, 2, 7, 7];

    var text12 = ["1. Opps, vad har apan fått syn på, tror du?",  "Berätta.",
      "2. Skriv en apas dagbok. Hur ser en dag ut?"   
    ];
    var text12_top = [30, 43, 56];
    var text12_left = [2,7, 2];

    var text13 = ["1. Skulle du vilja resa framåt eller bakåt", "i tiden? Berätta.",
      "2. Skriv en berättelse om tidsresan som höll", "på att sluta riktigt illa ..."     
    ];
    var text13_top = [30, 43,56, 69];
    var text13_left = [2, 7,2, 7];

    var text14 = ["1. Vem har byggt den här kojan, tror du?", "Berätta.",
      "2. Skriv en argumenterande text om varför", "alla borde få ha en egen trädkoja."      
    ];
    var text14_top = [30, 43, 56, 69];
    var text14_left = [2, 7, 2, 7];

    var text15 = ["1. Varför ser det ut såhär på stranden, tror du?", "Berätta.",
      "2. Skriv en insändare till en tidning om varför", "det är så viktigt att vi tar hand", "om vårt skräp."     
    ];
    var text15_top = [30, 43, 56, 69, 82];
    var text15_left = [2, 7, 2, 7, 7];

    var div_head = document.createElement("div");
    div_head.className = "finalBlock";
    div_head.style.fontSize = "1vw";
    div_head.style.fontFamily = "MyriadPro-Regular";
    div_head.style.fontWeight = "bold";
    div_head.style.position = "absolute";
    div_head.style.left = "2%";
    div_head.style.top = "15%";
    div_head.innerHTML = "Välj skrivuppgift";

    var div_notepad: any = document.createElement("img");
    div_notepad.src = bloburl + "/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/yr3_ins_notepad.png";
    div_notepad.className = "finalBlock";
    div_notepad.style.position = "absolute";
    div_notepad.style.left = "-2%";
    div_notepad.style.top = "-6%";
    div_notepad.style.width = "97%";
    div_notepad.style.height = "126%";


    var chapter_tagimg: any[string];
    chapter_tagimg = [bloburl + '/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/tagimages/chapter1.png',
      bloburl + '/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/tagimages/chapter2.png',
      bloburl + '/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/tagimages/chapter3.png',
      bloburl + '/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/tagimages/chapter4.png',
      bloburl + '/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/tagimages/chapter5.png',
      bloburl + '/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/tagimages/chapter6.png',
      bloburl + '/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/tagimages/chapter7.png',
      bloburl + '/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/tagimages/chapter8.png',
      bloburl + '/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/tagimages/chapter9.png',
      bloburl + '/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/tagimages/chapter10.png',
      bloburl + '/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/tagimages/chapter11.png',
      bloburl + '/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/tagimages/chapter12.png',
      bloburl + '/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/tagimages/chapter13.png',
      bloburl + '/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/tagimages/chapter14.png',
      bloburl + '/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/tagimages/chapter15.png'];

    var div_img: any = document.createElement("img");
    div_img.src = chapter_tagimg[t];
    div_img.className = "finalBlock";
    div_img.style.position = "absolute";
    div_img.style.left = "-13.3%";
    div_img.style.top = "-85.8%";
    div_img.style.width = "53.9%";
    choosetext.appendChild(div_img);
    choosetext.appendChild(div_notepad);
    choosetext.appendChild(div_head);
    $("#stbladderdashedrect").addClass('dashedrectclass2');
    $("#stbladderroundrect").addClass('roundrect2');

    var textarray: any = [text1, text2, text3, text4, text5, text6, text7, text8, text9, text10, text11, text12, text13, text14, text15];
    var textarray_top: any = [text1_top, text2_top, text3_top, text4_top, text5_top, text6_top, text7_top, text8_top, text9_top, text10_top, text11_top, text12_top, text13_top, text14_top, text15_top];
    var textarray_left: any = [text1_left, text2_left, text3_left, text4_left, text5_left, text6_left, text7_left, text8_left, text9_left, text10_left, text11_left,
      text12_left, text13_left, text14_left, text15_left];

    for (var i = 0; i < textarray[t].length; i += 1) {

      var div1 = document.createElement("div");
      div1.className = "finalBlock";
      div1.style.fontSize = "0.8vw";
      div1.style.fontFamily = "MyriadPro-Regular";
      div1.style.fontWeight = "100";
      div1.style.position = "absolute";
      div1.style.left = textarray_left[t][i] + "%";
      div1.style.top = textarray_top[t][i] + "%";
      div1.style.wordWrap = "break-word";
      div1.style.lineHeight = "1.8";
      div1.innerHTML = textarray[t][i];
      choosetext.appendChild(div1);
    }
  }

  showimage(j) {

    //new concept for print btn
    var txt = $("#textfield").text();
    if (txt) {
     
      this.hideshowprintbtn(1);
    }
    else {
      this.hideshowprintbtn(2);
    }


    //typing text after placing the image in safari
    var issafari_browser = navigator.userAgent.indexOf('Mac OS X') != -1;
    if (issafari_browser) {
      var a = $("#textfield").text();
      if (!a || a == "") {
        $("#textfield").prepend("&nbsp;");
      }
    }


    var bloburl = this.sessionService.bloburl;
    var elem = document.getElementById("textfield");
    var elem_notepad = document.getElementById("notepad");

    var copy_text = document.getElementById("copy_text");
    var elembody = document.getElementsByTagName("body")[0];
    var imgarr1: any[string];
    imgarr1 = [
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image1.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image2.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image3.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image4.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image5.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image6.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image7.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image8.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image9.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image10.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image11.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image12.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image13.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image14.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image15.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image18.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image16.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image17.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image19.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image20.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image21.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image22.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image23.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image24.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image25.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image26.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image27.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image28.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image29.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image30.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image31.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image32.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image33.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image34.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image35.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image36.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image37.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image38.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image39.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image40.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image41.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image42.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image43.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image44.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image45.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image46.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image47.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image48.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image49.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image50.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image51.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image52.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image53.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image54.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image55.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image56.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image57.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image58.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image59.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image60.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image61.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image62.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image63.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image64.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image65.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image66.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image67.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image68.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image69.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image70.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image71.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image72.png',

      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image73.jpg',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image74.jpg',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image75.jpg',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image76.jpg',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image77.jpg',

      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image78.jpg',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image79.jpg',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image80.jpg',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image81.jpg',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image82.jpg',

      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image83.jpg',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image84.jpg',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image85.jpg',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image86.jpg',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image87.jpg',
    ];

    imgarr1.width = [109, 129, 125, 163, 109, 131, 128, 140, 101,
      122, 151, 109, 148, 166, 161, 95, 153, 147, 
      173, 159, 109, 156, 116, 174, 111, 94, 132,
      108, 203, 118, 114, 153, 203, 93, 149, 110,
      94, 123, 135, 121, 165, 118, 124, 66, 148,
      78, 136, 123, 145, 84, 177, 158, 95, 100,
      154, 167, 127, 178, 145, 114, 216, 181, 122,
      168, 173, 268, 176, 157, 144, 175, 170, 174,
      210, 210, 210, 210, 210, 210, 210, 210, 210,
      210, 210, 210, 210, 210, 210];

    imgarr1.height = [127, 116, 120, 99, 117, 108, 135, 91, 117,
      109, 128, 130, 110, 83, 80,123, 126, 126, 
      104, 97, 140, 135, 98, 129, 122, 95, 96,
      115, 97, 140, 128, 126, 106, 152, 164, 102,
      136, 175, 168, 113, 179, 138, 158, 143, 205,
      109, 199, 146, 133, 152, 172, 162, 143, 136,
      82, 118, 96, 120, 95, 114, 151, 98, 104,
      145, 108, 125, 90, 97, 120, 132, 77, 162,
      141, 140, 140, 140, 140, 140, 140, 141, 140,
      140, 140, 140, 140, 140, 140
    ];
   var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    if (isIOS) {
      imgarr1.width = [
        54.5, 64.5, 62.5, 81.5, 54.5, 65.5, 64, 70, 50.5,
        61, 75.5, 54.5, 74, 83, 80.5, 47.5, 76.5, 73.5,
        86.5, 79.5, 54.5, 78, 58, 87, 55.5, 47, 66,
        54, 101.5, 59, 57, 76.5, 101.5, 46.5, 74.5, 55,
        47, 61.5, 67.5, 60.5, 82.5, 59, 62, 33, 74,
        39, 68, 61.5, 72.5, 42, 88.5, 79, 47.5, 50,
        77, 83.5, 63.5, 89, 72.5, 57, 108, 90.5, 61,
        84, 86.5, 134, 88, 78.5, 72, 87.5, 85, 87,
        105, 105, 105, 105, 105, 105, 105, 105, 105,
        105, 105, 105, 105, 105, 105
      ];

      imgarr1.height = [
        63.5, 58, 60, 49.5, 58.5, 54, 67.5, 45.5, 58.5,
        54.5, 64, 65, 55, 41.5, 40, 61.5, 63, 63,
        52, 48.5, 70, 67.5, 49, 64.5, 61, 47.5, 48,
        57.5, 48.5, 70, 64, 63, 53, 76, 82, 51,
        68, 87.5, 84, 56.5, 89.5, 69, 79, 71.5, 102.5,
        54.5, 99.5, 73, 66.5, 76, 86, 81, 71.5, 68,
        41, 59, 48, 60, 47.5, 57, 75.5, 49, 52,
        72.5, 54, 62.5, 45, 48.5, 60, 66, 38.5, 81,
        70.5, 70, 70, 70, 70, 70, 70, 70.5, 70,
        70, 70, 70, 70, 70, 70
      ];

    }
    for (var s = 0; s < elem.children.length; s++) {
      if (elem.children[s].className == "draggableme1") {
        elem.removeChild(elem.children[s]);
        elem.innerHTML = '';
        s = s - 1;
      }
    }


    if (j < 72) {
      var choosetext = document.getElementById("choosetext");

      for (var s = 0; s < choosetext.children.length; s++) {
        if (choosetext.children[s].className == "finalBlock") {
          choosetext.removeChild(choosetext.children[s]);
          s = s - 1;
        }
      }
    }


    var div:any = document.createElement("div");
    div.style.position = "absolute";
    div.style.left = elem_notepad.offsetWidth / 2 - imgarr1.width[j] / 2 - 44 + 'px';
    div.style.top = elem_notepad.offsetHeight / 2 - imgarr1.height[j] / 2 - 64 + 'px';
    div.style.width = imgarr1.width[j]  + "px";
    div.style.height = imgarr1.height[j]  + "px";
    div.style.background = "FFFFFF";
    div.style.backgroundImage = "url('" + imgarr1[j] + "')";
    if (isIOS) {
      div.style.backgroundSize = imgarr1.width[j] + "px";
    }
    
    div.contentEditable = "false";
    div.style.cursor = 'pointer';
    if (j > 71) {
      $(div).addClass("draggableme1");
    } else {
      $(div).addClass("draggableme");
    }

    var closeimg = document.createElement('img');
    closeimg.src = bloburl + "/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/close.png";
    closeimg.style.display = "none";
    closeimg.style.position = "absolute";
    closeimg.style.left = elem_notepad.offsetWidth / 2 + imgarr1.width[j] / 2 - 60 + 'px';
    closeimg.style.top = elem_notepad.offsetHeight / 2 - imgarr1.height[j] / 2 - 79 + 'px';
    closeimg.style.zIndex = '1000';
    closeimg.width = 30;
    if (isIOS) {
      closeimg.width = 25;
    }
    closeimg.style.cursor = 'pointer';

    $(closeimg).addClass("closeimg");
    //new concept for print btn
    this.hideshowprintbtn(1);

    elem.appendChild(div);
    elem.appendChild(closeimg);


    var closetable1 = document.getElementById("yr3_st_bladder_imageTable2");
    closetable1.style.display = "none";

    var closetable2 = document.getElementById("yr3_st_bladder_imageTable3");
    closetable2.style.display = "none";

    var changecolor1 = document.getElementById("bladdercircle1");
    changecolor1.style.background = "#FFFFFF";

    var changecolor2 = document.getElementById("bladdercircle2");
    changecolor2.style.background = "#FFFFFF";

    var mousePosition;
    var offset = [0, 0, 0, 0];
    var isDown = false;

    div.addEventListener('mousedown', function (e) {
      e.preventDefault();
      isDown = true;
      offset = [
        div.offsetLeft - e.clientX,
        div.offsetTop - e.clientY,
        closeimg.offsetLeft - e.clientX,
        closeimg.offsetTop - e.clientY
      ];
    }, true);

    div.addEventListener('mouseup', function () {
      isDown = false;
    }, true);

    document.addEventListener('mouseup', function () {
      isDown = false;
    }, true);

    div.addEventListener('mousemove', function (event) {
      event.preventDefault();
      if (isDown) {
        mousePosition = {

          x: event.clientX,
          y: event.clientY,

          x1: event.clientX,
          y1: event.clientY

        };
        div.style.left = (mousePosition.x + offset[0]) + 'px';
        div.style.top = (mousePosition.y + offset[1]) + 'px';

        closeimg.style.left = (mousePosition.x1 + offset[0]) + imgarr1.width[j] - 15 + 'px';
        closeimg.style.top = (mousePosition.y1 + offset[1]) - 14 + 'px';
      }
      if (div.style.left == "0px") {
        return false;
      }
    }, true);



    div.addEventListener("touchstart", TouchOver);
    div.addEventListener("touchmove", TouchOver);
    
    closeimg.addEventListener("touchstart", function () {
      removeimg(closeimg, div);
    });
   

    div.addEventListener("mouseover", MouseOver);
    div.addEventListener("mouseleave", MouseLeave);
    closeimg.addEventListener("mouseover", MouseOver);
    closeimg.addEventListener("mouseleave", MouseLeave);

    function TouchOver(e) {
      $(".draggableme").css("border", "none");
      $(".closeimg").css("display", "none");
      $(".draggableme1").css("border", "none");
      div.style.border = "#000000 1px solid";
      closeimg.style.display = "block";
    }
    function MouseOver() {
      div.style.border = "#000000 1px solid";
      closeimg.style.display = "block";
    }
    function MouseLeave() {
      div.style.border = "none";
      closeimg.style.display = "none";
    }

    closeimg.addEventListener("click", function () {
      removeimg(closeimg, div);
    });
    closeimg.addEventListener("mousedown", function () {
      removeimg(closeimg, div);
    });
    

    //New concept for print btn
    function hideshowprintbtn(st) {
      if (st == 1) {
        $("#printpdf").removeClass("disabled_me");
      }
      else {
        $("#printpdf").addClass("disabled_me");
      }
    }
    //New concept
    var issafari_browser = navigator.userAgent.indexOf('Mac OS X') != -1;
    if (issafari_browser) {
      var a = $("#textfield").text();
      if (!a || a == "") {
        $("#textfield").prepend("&nbsp;");
      }
    }
    function removeimg(closeimg_temp, div_temp) {
      $(div_temp).remove();
      $(closeimg_temp).remove();
      //New concept for print btn
      var b = $("#textfield").text();
      var images = $(".draggableme");
      if (b == "" && images) {
        if (images.length == 0) {
          hideshowprintbtn(2);
        }
      }
      else if (b == "") {
        hideshowprintbtn(2);
      }
      //New concept
     
      var choosetext = document.getElementById("choosetext");
      for (var s = 0; s < choosetext.children.length; s++) {
        if (choosetext.children[s].className == "finalBlock") {
          choosetext.removeChild(choosetext.children[s]);
          s = s - 1;
        }
      }
    }
  }
  removeborder() {
    $("#stbladderdashedrect").removeClass('dashedrectclass2');
    $("#stbladderroundrect").removeClass('roundrect2');
  }

  onCloseCancel() {    
    this.thisDialogRef.close('Cancel');   
  }

}

